import React, { Component } from "react";
import { connect } from "react-redux";
import { customerListActions, sessionActions } from "./../../../actions";
import _ from "lodash";
import { PropTypes } from "prop-types";
import { RightPanel } from "../../../components";
import "./style.css";
import Select from "react-select";
import useGetCustomer from "../../../hooks/CustomerProfile/useGetCustomer";
import useSession from "../../../hooks/Auth/useSession";
import Button from "../../Button/Button";
import AccountToggle from "./AccountToggle/AccountToggle";
import * as UserTypes from "../../../utils/UserTypes";
import { config } from "../../../utils/conf";
import { authorize, Roles } from "../../../utils/AuthService";

function useCurrentCustomer() {
  const { customerId } = useSession();
  const { data: customer, isLoading } = useGetCustomer(customerId);
  return { customer, isLoading };
}

function CustomerName() {
  const { customer, isLoading } = useCurrentCustomer();
  return <div>{isLoading ? "Loading..." : customer?.customerName}</div>;
}

const ACTIVE_STATUSES = ["ACTIVE", "ON HOLD", "INBOUND"];

class SwitchAccount extends Component {
  static contextTypes = {
    router: PropTypes.object,
  };

  state = {
    showModal: false,
    dropDownPlaceholder: "Select a customer",
    selectedCustomer: null,
    showRightPanel: false,
    showActiveCustomersOnly: true,
    selectedCustomerType: "ALL",
    userTypesInRoles: [],
  };

  onModalOpen = () => {};

  showModal = (e) => {
    if (e) e.preventDefault();
    // this.setState({ showModal: true });
    if (this.props.changeOrgPending || this.props.fetching) return;

    const { accessToken, dispatch, customer } = this.props;

    if (this.props.customers && this.props.customers.length) {
      return;
    }
    dispatch(
      customerListActions.fetchCustomers(
        accessToken,
        config.singleSign ? undefined : customer?.customerType,
      ),
    );
  };

  onModalClose = () => {
    this.props.dispatch(sessionActions.resetChangeOrgState());
    this.props.dispatch(customerListActions.resetState());

    this.setState({ showModal: false });
  };

  componentDidMount() {
    this.setState({
      userTypesInRoles: this.props.user.Roles.filter(
        (role) => role.RoleName === "Outbound" || role.RoleName === "Inbound",
      ),
    });
  }

  componentWillUnmount() {
    this.props.dispatch(sessionActions.resetChangeOrgState());
    this.props.dispatch(customerListActions.resetState());
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (
      prevProps.changeOrgPending &&
      this.props.changeOrgCompleted &&
      this.props.customer?.customerType
    ) {
      setTimeout(() => {
        window.location.reload();
      }, 300);
    }
  };

  onSwitchUserClick = () => {
    const customerId = this.state.selectedCustomer.id;

    let history = this.context.router.history;
    history.push({
      pathname: "/switch-account",
      state: { ...history.location.state, customerId },
    });
  };

  openNav = (e) => {
    e.stopPropagation();
    e.preventDefault();
    this.showModal();
    this.setState((previousState) => ({
      showRightPanel: !previousState.showRightPanel,
    }));
  };

  closeFilterPanel = () => {
    this.setState({ showRightPanel: false, selectedCustomer: null });
  };

  changeCustomerType = (customerType) => {
    this.setState({
      selectedCustomerType: customerType,
      selectedCustomer: null,
    });
  };

  render() {
    let customers = [...this.props.customers];
    var customerType = this.props.customer?.customerType;
    const isAdmin = authorize(
      this.props.user,
      Roles.ADMINISTRATOR,
      Roles.CUSTOMER_SERVICE,
    );

    if (isAdmin && this.state.showActiveCustomersOnly) {
      customers = customers.filter((customer) =>
        ACTIVE_STATUSES.includes(customer.status),
      );
    }

    if (isAdmin && this.state.selectedCustomerType !== "ALL") {
      customers = customers.filter(
        (customer) => customer.type === this.state.selectedCustomerType,
      );
    }

    if (this.state.userTypesInRoles.length === 1) {
      customers = customers.filter(
        (customer) =>
          customer.type ===
          (this.state.userTypesInRoles[0].RoleName === "Outbound"
            ? UserTypes.OUTBOUND
            : UserTypes.INBOUND),
      );
    }

    if (this.state.userTypesInRoles.length === 0 && customerType) {
      customers = customers.filter(
        (customer) => customer.type === customerType,
      );
    }

    return (
      <React.Fragment>
        {
          <>
            <a href="/" role="button" onClick={this.openNav}>
              Switch Account
            </a>

            <RightPanel
              display={this.state.showRightPanel}
              close={() => {
                this.setState({ showRightPanel: false });
              }}
            >
              <div className="tw-p-8 tw-pt-12 tw-font-inter ">
                <div className="tw-font-semibold tw-text-dark tw-text-base tw-mb-10">
                  Switch Account
                </div>

                <p className="tw-text-xs tw-font-semibold tw-mb-0">
                  Your current account
                </p>
                <div className="tw-text-tosca-orange tw-text-2xl">
                  <CustomerName />
                </div>

                {isAdmin && (
                  <div className="tw-flex tw-items-baseline tw-justify-between">
                    <div className="tw-flex tw-items-baseline tw-mt-8">
                      <p className="tw-text-xs tw-font-semibold">
                        Switch Account To{" "}
                        <span className="tw-text-xs tw-font-semibold tw-text-tosca-orange">
                          {this.state.showActiveCustomersOnly
                            ? "Active"
                            : "All"}
                        </span>
                      </p>
                    </div>

                    <AccountToggle
                      onToggle={(isOn) =>
                        this.setState({
                          showActiveCustomersOnly: isOn,
                          selectedCustomer: null,
                        })
                      }
                    />
                  </div>
                )}

                {isAdmin &&
                  config.singleSign &&
                  this.state.userTypesInRoles.length === 2 && (
                    <>
                      {/* <div className="tw-text-sm tw-mt-2 tw-text-[#969eaa] tw-font-light "> */}
                      <div className="tw-text-sm tw-mt-2 tw-text-[#8e97a4] tw-font-light ">
                        <p>Filter by type</p>
                      </div>

                      <div className="tw-flex tw-justify-evenly tw-items-center tw-rounded-md tw-p-1 tw-h-10 tw-w-full tw-bg-[#f3f4f6] tw-mb-5 tw-gap-2">
                        <div
                          className={`${
                            this.state.selectedCustomerType === "ALL"
                              ? "tw-bg-white"
                              : ""
                          }  tw-flex tw-flex-1 tw-h-full tw-items-center tw-p-1  tw-rounded-md tw-cursor-pointer`}
                          onClick={() => this.changeCustomerType("ALL")}
                        >
                          All
                        </div>

                        <div
                          className={`${
                            this.state.selectedCustomerType === "COLLECTION"
                              ? "tw-bg-white"
                              : ""
                          }  tw-flex tw-flex-1 tw-h-full tw-items-center tw-p-1 tw-rounded-md tw-cursor-pointer`}
                          onClick={() => this.changeCustomerType("COLLECTION")}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth="1.5"
                            stroke="currentColor"
                            className="tw-w-4 tw-h-4 tw-mr-1"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="m9 12.75 3 3m0 0 3-3m-3 3v-7.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                            />
                          </svg>
                          Inbound
                        </div>

                        <div
                          className={`${
                            this.state.selectedCustomerType === "OUTBOUND"
                              ? "tw-bg-white"
                              : ""
                          }  tw-flex tw-flex-1 tw-h-full tw-items-center tw-p-1 tw-rounded-md tw-cursor-pointer`}
                          onClick={() => this.changeCustomerType("OUTBOUND")}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth="1.5"
                            stroke="currentColor"
                            className="tw-w-4 tw-h-4 tw-mr-1"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="m15 11.25-3-3m0 0-3 3m3-3v7.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                            />
                          </svg>
                          Outbound
                        </div>
                      </div>
                    </>
                  )}

                <Select
                  id="filterCustomer"
                  name="customer"
                  className="react-select tw-font-museo"
                  backspaceRemovesValue={true}
                  options={customers}
                  value={this.state.selectedCustomer}
                  isLoading={this.props.changeOrgPending || this.props.fetching}
                  isDisabled={
                    this.props.changeOrgPending || this.props.fetching
                  }
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: "4px",
                    colors: {
                      ...theme.colors,
                      primary25: "#E0E0E0",
                      primary: "#E0E0E0",
                    },
                  })}
                  onChange={(option) => {
                    this.setState({
                      selectedCustomer: option,
                    });
                  }}
                  getOptionLabel={(option) => `${option.name}`}
                  getOptionValue={(option) => option.id}
                  onFocus={() => {
                    this.setState({
                      dropDownPlaceholder: this.state.showActiveCustomersOnly
                        ? "Active"
                        : "All",
                    });
                  }}
                  onBlur={() => {
                    this.setState({
                      dropDownPlaceholder: "Select a customer",
                    });
                  }}
                  labelWrapperClass="tw-mb-2"
                  inputWrapperClass=""
                  placeholder={this.state.dropDownPlaceholder}
                />

                {config.singleSign && (
                  <div className="tw-text-sm tw-mt-2 tw-text-[#969eaa] tw-font-light ">
                    <p>{`${customers.length} customers available`}</p>
                  </div>
                )}

                <div className="tw-text-sm tw-mt-2 tw-text-red-500 tw-font-semibold">
                  {this.props.fetchError && !this.props.fetching ? (
                    <p>Could not fetch customers</p>
                  ) : (
                    ""
                  )}
                  {this.props.changeOrgError ? (
                    <p>
                      {_.get(
                        this.props.changeOrgError,
                        "response.data.message",
                        "Network error.",
                      )}
                    </p>
                  ) : (
                    ""
                  )}
                </div>

                {this.props.changeOrgCompleted &&
                this.props.customer?.customerType ? (
                  <div className="tw-text-green-500 tw-mt-2">
                    <p className="tw-text-green-500 tw-font-semibold tw-text-sm">
                      Success.
                    </p>
                  </div>
                ) : null}

                <div className="tw-mt-8 tw-grid tw-grid-cols-2 tw-gap-4">
                  <Button
                    brand="primary"
                    size="md"
                    disabled={
                      !this.state.selectedCustomer ||
                      this.props.changeOrgPending
                    }
                    onClick={this.onSwitchUserClick}
                  >
                    Switch User
                  </Button>
                  <Button
                    size="md"
                    brand="secondary"
                    onClick={this.closeFilterPanel}
                  >
                    Clear
                  </Button>
                </div>
              </div>
            </RightPanel>
          </>
        }
      </React.Fragment>
    );
  }
}

const mapState = ({ session, customers, login }) => ({
  user: session.user,
  accessToken: session.user.accessToken,
  customers: _.orderBy(customers.customers, "name", "asc"),
  fetching: customers.fetching,
  fetchError: customers.error,
  changeOrgPending: login.changeOrgFetching,
  changeOrgCompleted: login.changeOrgFetched,
  changeOrgError: login.changeOrgError,
});

const ConnectedSwitchAccount = connect(mapState)(SwitchAccount);

export default function SwitchAccountWithCustomerType(props) {
  const { customer } = useCurrentCustomer();

  return <ConnectedSwitchAccount {...props} customer={customer} />;
}
